import PropTypes from 'prop-types';
import {
  getTourRateAgeLabel,
  getTourRateNameWithoutAge,
} from '../../../../../helpers/getTourRateAge';
import buildTourRateQuantities from '../../../../../helpers/buildTourRateQuantities';

const TourRateSelect = ({ rate, value, minQuantity, maxQuantity, onChange }) => {
  const parameterName = rate.parameterName || rate.name;
  const options = buildTourRateQuantities(rate, value, minQuantity, maxQuantity);
  const label = getTourRateNameWithoutAge(rate);
  const hint = getTourRateAgeLabel(rate);

  return (
    <div className="flex items-center justify-between py-1 gap-3">
      <span className="min-w-0 truncate" title={rate.name}>
        {label}
        {hint && <span className="text-gray-500"> ({hint})</span>}
      </span>
      <select
        className="border rounded px-2 py-0.5 w-16 flex-shrink-0"
        value={value}
        onChange={(event) => onChange(parameterName, Number.parseInt(event.target.value, 10))}
      >
        <option value={0}>-</option>
        {options.map((count) => (
          <option key={count} value={count}>
            {count}
          </option>
        ))}
      </select>
    </div>
  );
};

TourRateSelect.propTypes = {
  rate: PropTypes.shape().isRequired,
  value: PropTypes.number,
  minQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

TourRateSelect.defaultProps = {
  value: 0,
  minQuantity: null,
  maxQuantity: null,
};

export default TourRateSelect;
